import React from 'react'
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,

} from "@mui/material";
import instance from '../../Utils/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Cataloguestatus = ({ statusDialog, setstatusDialog, selectedCategory, setgetCategory, setgetsubCategory, mode, selectedsubCategory }) => {

    const handleClose = () => {
        setstatusDialog(false);
    }
    
    //handlecategoryStatus
    const handlecategoryStatus = async () => {
        try {
            const response = await instance.patch(`/Catalogue/toggleCategoryStatus?_id=${selectedCategory.categoryId}`,)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetCategory(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message); // Handle errors
        }
    }

    //handlesubcategoryStatus
    const handlesubcategoryStatus = async () => {
        try {
            const response = await instance.patch(`/Catalogue/toggleSubCategoryStatus?_id=${selectedsubCategory.subcategoryId}`,)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetsubCategory(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message); // Handle errors
        }
    }


    return (
        <>
            {mode === "category" ?
                (
                    <React.Fragment>
                        <BootstrapDialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={statusDialog}
                            className="admin-admins"
                        >
                            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                Update Status
                            </DialogTitle>
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <DialogContent dividers>
                                <Typography>
                                    Are you sure you want to update the status of <strong>{selectedCategory?.category} </strong>?
                                </Typography>
                            </DialogContent>
                            <DialogActions >
                                <Button className="cancel-btn" onClick={handleClose}>Cancel</Button>
                                <Button className="add-btn" onClick={handlecategoryStatus}>Confirm</Button>
                            </DialogActions>
                        </BootstrapDialog>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <BootstrapDialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={statusDialog}
                            className="admin-admins"
                        >
                            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                Update Status
                            </DialogTitle>
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <DialogContent dividers>
                                <Typography>
                                Are you sure you want to update the status of <strong>{selectedsubCategory?.subCategory} </strong>?
                                </Typography>
                            </DialogContent>
                            <DialogActions >
                                <Button className="cancel-btn" onClick={handleClose}>Cancel</Button>
                                <Button className="add-btn" onClick={handlesubcategoryStatus}>Confirm</Button>
                            </DialogActions>
                        </BootstrapDialog>
                    </React.Fragment>
                )
            }
        </>
    )
}

export default Cataloguestatus;